import {Specialization} from "@web-libs/features/appointments/domain/appointment.types";
import {Tab} from "@web-libs/features/appointments/ui/booking/tabs/tab";

type TabsProps = {
    specializations: Specialization[]
    onSpecializationSelected: (specialization: Specialization) => void
    activeSpecialization: Specialization
}
export const Tabs = (props: TabsProps) => {
    const isSpec = props.activeSpecialization;
    return (
        <div style={{display:"flex", flexWrap:"wrap"}}>
            {props.specializations.map(specialization => {
                return (
                    <Tab style={{marginRight:8, marginBottom:8}} key={specialization.id} active={ isSpec ? ((props.activeSpecialization as Specialization).id === specialization.id) :false } onClick={() => props.onSpecializationSelected(specialization)} name={specialization.name}/>
                )
            })}
        </div>
    )
}
